<p-menubar [model]="items">
    <ng-template pTemplate="start">
        <a href="https://www.audi.co.za/za/web/en.html">
            <img src="assets/images/audi-rings.svg" alt="Audi Rings" height="25" class="p-mr-2 rings"></a>
    </ng-template>
</p-menubar>